export const PET_COLORS = [
  { value: "negro",    label: "Negro" },
  { value: "blanco",   label: "Blanco" },
  { value: "marron",   label: "Marrón" },
  { value: "gris",     label: "Gris" },
  { value: "naranja",  label: "Naranja" },
  { value: "dorado",   label: "Dorado" },
  { value: "crema",    label: "Crema" },
  { value: "atigrado", label: "Atigrado" },
  { value: "manchado", label: "Manchado" },
];

/**
 * Convert a legacy color field (string or array) to an array of values.
 * Handles: null, string ("negro"), comma-separated ("negro, blanco"), and arrays.
 */
export function parseColorField(color) {
  if (!color) return [];
  if (Array.isArray(color)) return color;
  return color.split(",").map(c => c.trim().toLowerCase()).filter(Boolean);
}

/**
 * Get the display label for a color value.
 */
export function getColorLabel(value) {
  const found = PET_COLORS.find(c => c.value === value);
  return found ? found.label : value;
}
